export default __webpack_public_path__ + "static/media/WorkingWithTokens.2e35df9d.mp4";